const now = () => new Date().toISOString();
const uuid = () => crypto.randomUUID();
export async function startChecklistRun(db, actor, input) {
    const id = uuid();
    await db.execute(`insert into checklist_runs (id, entity_id, chantier_id, template_id, date, results, status, performed_by, device_id, device_ts, updated_at) values (?, ?, ?, ?, ?, '{}', 'draft', ?, ?, ?, ?)`, [id, input.entityId ?? null, input.chantierId, input.templateId, input.date, actor.userId, actor.deviceId, now(), now()]);
    return id;
}
export async function saveChecklistResults(db, runId, results, status = "draft") {
    await db.execute(`update checklist_runs set results = ?, status = ?, updated_at = ? where id = ?`, [JSON.stringify(results), status, now(), runId]);
}
/** Upsert by (chantier, date); the server keeps the same uniqueness. */
export async function upsertDailyReport(db, actor, input, existingId) {
    if (existingId) {
        await db.execute(`update daily_reports set weather = ?, remarks = ?, incidents = ?, visitors = ?, updated_at = ? where id = ?`, [input.weather ?? null, input.remarks ?? null, JSON.stringify(input.incidents ?? []), input.visitors ?? null, now(), existingId]);
        return existingId;
    }
    const id = uuid();
    await db.execute(`insert into daily_reports (id, entity_id, chantier_id, date, weather, remarks, incidents, visitors, status, created_by, device_id, device_ts, updated_at) values (?, ?, ?, ?, ?, ?, ?, ?, 'draft', ?, ?, ?, ?)`, [id, input.entityId ?? null, input.chantierId, input.date, input.weather ?? null, input.remarks ?? null, JSON.stringify(input.incidents ?? []), input.visitors ?? null, actor.userId, actor.deviceId, now(), now()]);
    return id;
}
export async function signDailyReport(db, actor, reportId, signatureAttachmentId) {
    await db.execute(`update daily_reports set status = 'signed', signed_by = ?, signed_at = ?, signature_attachment_id = ?, updated_at = ? where id = ?`, [actor.userId, now(), signatureAttachmentId, now(), reportId]);
}
export async function stampMissionOrder(db, actor, input) {
    let visas = {};
    try {
        visas = input.currentVisas ? JSON.parse(input.currentVisas) : {};
    }
    catch {
        visas = {};
    }
    visas[input.type] = { ts: now(), by: actor.userId, gps: input.gps ?? null, note: input.note ?? null };
    const status = input.type === "return" ? "returned" : input.currentStatus === "issued" ? "arrived" : input.currentStatus;
    await db.execute(`update mission_orders set visas = ?, status = ?, updated_at = ? where id = ?`, [JSON.stringify(visas), status, now(), input.id]);
}
//# sourceMappingURL=site-mutations.js.map